export default __webpack_public_path__ + "static/media/none-icon.92e69b94.png";